export const collection = 'packaging';
export const productPath = 'product_image';
